import type { StyledProps } from '@compiled/react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import type { ComponentType, ClassAttributes, ButtonHTMLAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoryPill: ComponentType<
	{
		isSelected?: boolean;
		isDisabled?: boolean;
	} & ClassAttributes<HTMLButtonElement> &
		ButtonHTMLAttributes<HTMLButtonElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.button<{
	isSelected?: boolean;
	isDisabled?: boolean;
}>({
	outline: 'none',
	boxSizing: 'border-box',
	padding: `3px ${token('space.075')} ${token('space.050')} ${token('space.075')}`,
	transition: '0.2s ease',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: ({ isDisabled, isSelected }) =>
		isDisabled || !isSelected
			? token('color.background.neutral')
			: token('color.background.selected'),
	display: 'inline-flex',
	borderWidth: token('border.width'),
	borderStyle: 'solid',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	borderColor: ({ isDisabled, isSelected }) =>
		isDisabled || !isSelected ? 'transparent' : token('color.text.selected'),
	borderRadius: token('radius.full'),
	font: token('font.body'),
	height: '26px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: ({ isDisabled, isSelected }) =>
		isDisabled || !isSelected ? token('color.text') : token('color.text.selected'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	cursor: ({ isDisabled }) => (isDisabled ? 'inherit' : 'pointer'),
	marginTop: 0,
	marginBottom: token('space.100'),
	marginRight: token('space.050'),
	userSelect: 'none',
	maxWidth: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	verticalAlign: 'top',

	'&:focus': {
		boxShadow: `0 0 0 2px ${token('color.border.selected')}`,
	},
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		backgroundColor: ({ isDisabled, isSelected }) => {
			if (isDisabled) {
				return token('color.background.neutral');
			}
			if (isSelected) {
				return token('color.background.selected.hovered');
			}
			return token('color.background.neutral.hovered');
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EllipsisPill: ComponentType<
	{
		isSelected?: boolean;
		isDisabled?: boolean;
	} & ClassAttributes<HTMLButtonElement> &
		ButtonHTMLAttributes<HTMLButtonElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled(CategoryPill)({
	paddingLeft: '4px',
	paddingRight: '4px',
	verticalAlign: 'top',
	marginRight: 0,
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PlaceholderPill: ComponentType<
	{
		width: number;
	} & {
		isSelected?: boolean;
		isDisabled?: boolean;
	} & ClassAttributes<HTMLButtonElement> &
		ButtonHTMLAttributes<HTMLButtonElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled(CategoryPill)<{ width: number }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: `${({ width }) => width}px`,
	flexShrink: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TextWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div({
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	flexShrink: 1,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoryNameWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div({
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TrophyIconWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div({
	margin: `1px ${token('space.075')} 1px 0px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FireIconWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div({
	margin: `0px ${token('space.075')} 1px 0px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StarIconWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div({
	margin: `1px ${token('space.075')} 0px 0px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div({
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Bold: ComponentType<
	ClassAttributes<HTMLSpanElement> & HTMLAttributes<HTMLSpanElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.span({
	fontWeight: token('font.weight.semibold'),
	flexShrink: 0,
	marginLeft: token('space.075'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoCountSpace: ComponentType<
	ClassAttributes<HTMLSpanElement> & HTMLAttributes<HTMLSpanElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.span({
	marginLeft: token('space.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineDialogContentWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div({
	maxWidth: '260px',
	padding: token('space.200'),
	boxSizing: 'border-box',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoryList: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		paddingLeft: 0,
	},
});

export const COLLAPSED_INLINE_WRAPPER_HEIGHT = 26;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineCategorySelectorWrapper: ComponentType<
	{
		isCollapsed?: boolean;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled.div<{
	isCollapsed?: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ isCollapsed }) => (isCollapsed ? `${COLLAPSED_INLINE_WRAPPER_HEIGHT}px` : 'auto'),
	padding: `${token('space.025')} ${token('space.025')} ${token('space.050')}`,
	overflow: 'hidden',
	position: 'relative',
	display: 'flex',
	alignItems: 'flex-start',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineExpandCollapsePill: ComponentType<
	{
		isSelected?: boolean;
	} & {
		isSelected?: boolean;
		isDisabled?: boolean;
	} & ClassAttributes<HTMLButtonElement> &
		ButtonHTMLAttributes<HTMLButtonElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled(CategoryPill)<{
	isSelected?: boolean;
}>({
	display: 'inline-flex',
	alignItems: 'center',
	height: '24px',
	padding: 0,
	marginTop: '1px',
	marginBottom: '1px',
	marginLeft: 0,
	marginRight: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PlaceholderExpandPill: ComponentType<
	{
		width: number;
	} & {
		isSelected?: boolean;
		isDisabled?: boolean;
	} & ClassAttributes<HTMLButtonElement> &
		ButtonHTMLAttributes<HTMLButtonElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled(PlaceholderPill)({
	height: '24px',
	marginTop: '1px',
	marginBottom: '1px',
	marginLeft: 0,
	marginRight: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineCategoryList: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
> = styled(CategoryList)({
	maxWidth: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> .hidden': {
		display: 'none',
	},
});
